import React, { useState, useRef } from 'react';
import Typical from 'react-typical';
import emailjs from 'emailjs-com';

import imgBack from '../../../src/images/mailz.jpeg';
import load1 from '../../../src/images/load2.gif';
import ScreenHeading from '../../utilities/ScreenHeading/ScreenHeading';
import ScrollService from '../../utilities/ScrollService';
import Animations from '../../utilities/Animations';
import Footer from '../../components/footer/Footer';
import './ContactMe.css';

export default function ContactMe(props) {
	let fadeInScreenHandler = (screen) => {
		if (screen.fadeInScreen !== props.id) return;
		Animations.animations.fadeInScreen(props.id);
	};

	const fadeInSubscription =
		ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

	const formRef = useRef();
	const [done, setDone] = useState(false);
	const [banner, setBanner] = useState('');
	const [bool, setBool] = useState(false);

	const submitForm = async (e) => {
		e.preventDefault();

		emailjs
			.sendForm(
				'service_2nm37vf',
				'template_a3ntdpi',
				formRef.current,
				'user_LjPzaJa81jiROkhkCzi8b'
			)
			.then(
				(result) => {
					console.log(result.text);
					setDone(true);
				},
				(error) => {
					console.log(error.text);
				}
			);
	};

	return (
		<div className='main-container fade-in' id={props.id || ''}>
			<ScreenHeading subHeading={'Lets Keep In Touch'} title={'Contact Me'} />
			<div className='central-form'>
				<div className='col'>
					<h2 className='title'>
						<Typical loop={Infinity} steps={['Get In Touch 📧', 1000]} />
					</h2>{' '}
					<a
						href='https://www.facebook.com/khang.burn.7'
						target='_blank'
						rel='noopener noreferrer'
					>
						<i className='fa fa-facebook-square'></i>
					</a>
					<a
						href='https://www.instagram.com/nduc_kh/'
						target='_blank'
						rel='noopener noreferrer'
					>
						<i className='fa fa-instagram'></i>
					</a>
					<a
						href='https://github.com/duckhang2210'
						target='_blank'
						rel='noopener noreferrer'
					>
						<i className='fa fa-github'></i>
					</a>
					<a
						href='https://www.linkedin.com/in/duc-khang-nguyen-606b62128/'
						target='_blank'
						rel='noopener noreferrer'
					>
						<i className='fa fa-linkedin-square'></i>
					</a>
				</div>
				<div className='back-form'>
					<div className='img-back'>
						<h4>Send Your Email Here!</h4>
						<img src={imgBack} alt='image not found' />
					</div>
					<form ref={formRef} onSubmit={submitForm}>
						<p>{banner}</p>
						<label htmlFor='name'>Name</label>
						<input type='text' placeholder='Name' name='user_name' />

						<label htmlFor='email'>Email</label>
						<input type='text' placeholder='Email' name='user_email' />

						<label htmlFor='email'>Subject</label>
						<input type='text' placeholder='Subject' name='user_subject' />

						<label htmlFor='message'>Message</label>
						<textarea name='message' rows='5' placeholder='Message' />

						<div className='send-btn'>
							<button type='submit'>
								send
								<i className='fa fa-paper-plane' />
								{bool ? (
									<b className='load'>
										<img src={load1} alt='image not responding' />
									</b>
								) : (
									''
								)}
							</button>
							{done && (
								<p>Thank You for Your Email. I'll respond within a day.</p>
							)}
						</div>
					</form>
				</div>
			</div>
			<Footer />
		</div>
	);
}
